import { render, staticRenderFns } from "./TheLayoutResponsive.vue?vue&type=template&id=68fed41e&scoped=true&"
import script from "./TheLayoutResponsive.vue?vue&type=script&lang=ts&"
export * from "./TheLayoutResponsive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fed41e",
  null
  
)

export default component.exports